import script from "./AppRunning.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRunning.vue?vue&type=script&setup=true&lang=js"

import "./AppRunning.vue?vue&type=style&index=0&id=12b731c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b731c3"]])

export default __exports__